module.exports = __webpack_public_path__ + "img/version-down.0d24f098.svg";